import loadable from '@loadable/component';

import { CmsApiRandomGradProgramsBlockData } from 'modules/cms/api/types/blocks/CmsApiRandomGradProgramsBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsRandomGradProgramsBlockMapping: CmsBlockMapping<CmsApiRandomGradProgramsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsRandomGradProgramsBlock'), {
        resolveComponent: (module) => module.CmsRandomGradProgramsBlock,
      }),
    ),
    AmpComponent: loadable(() => import('./CmsAmpRandomGradProgramsBlock'), {
      resolveComponent: (module) => module.CmsAmpRandomGradProgramsBlock,
    }),
  };
